import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const ModalOverlayWrapper = styled.div`
    display: ${props => props.open ? 'block' : 'none'};
    position: fixed;
    z-index: 1; 
    left: 0;
    top: 0;
    width: 100%; 
    height: 100%;
    overflow: auto; 
    background-color: rgb(0,0,0);
    background-color: rgba(0,0,0,0.4);
`
const ModalContentWrapper = styled.div`
    background-color: #fefefe;
    width: fit-content;
    height: auto;
    margin: 15% auto;
    padding: 20px;
    border: 1px solid #888;
    border-radius: 10px;
    box-sizing: content-box;
`
const CloseButtonWrapper = styled.div`
    opacity: 0.3;
    display: flex;
    justify-content: flex-end;
    &:hover{
        opacity: 1;
    }

    & > div {
        margin: 0px;
        font-size: 20px;
        cursor: pointer;
    }
`

const CompanyModalWindow = ({open, onClose, children}) => {
    return (
        <ModalOverlayWrapper open={open} >
            <ModalContentWrapper >
                <CloseButtonWrapper> 
                    <div onClick={onClose}>X</div> 
                </CloseButtonWrapper>
                {children}
            </ModalContentWrapper>
        </ModalOverlayWrapper>
    )
}

CompanyModalWindow.propTypes = {
    /** Boolean value that defines if the window is visible or not */
    open: PropTypes.bool,
    /** Function to handle the dialog closing */
    onClose: PropTypes.func,
    /** Children to be displayed within the dialog */
    children: PropTypes.any
}

export default CompanyModalWindow;


// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/CompanyModalWindow.jsx